import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import GlobalNav from "./components/layout/GlobalNav";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import StudentDashboard from "./pages/StudentDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import Quizzes from "./pages/Quizzes";
import AiTutor from "./pages/AiTutor";
import Login from "./pages/Login";
import ModulePage from "./pages/ModulePage";
import LessonsHub from "./pages/LessonsHub";
import QuizRunner from "./pages/QuizRunner";
import Impressum from "./pages/Impressum";
import Register from "./pages/Register";
import RegisterTeacher from "./pages/RegisterTeacher";
import RegisterStudent from "./pages/RegisterStudent";

function AppContent() {
  const location = useLocation();

  // Seiten OHNE Sidebar (Footer ist in der Seite selbst)
  const pagesWithoutSidebar = [
    "/",
    "/login",
    "/register",
    "/register-student",
    "/register-teacher",
  ];
  const showGlobalFooter = !pagesWithoutSidebar.includes(location.pathname);

  // Seiten OHNE GlobalNav (z.B. Quiz)
  const isQuizPage = location.pathname.startsWith("/quiz/");
  const showGlobalNav = !isQuizPage && !pagesWithoutSidebar.includes(location.pathname);

  // Hat diese Seite eine linke Sidebar (GlobalNav)?
  const hasSidebar = showGlobalNav;

  return (
    <>
      {showGlobalNav && <GlobalNav />}

      <div className={`app-main-wrapper ${hasSidebar ? "with-sidebar" : ""}`}>
        <main className="flex-grow-1" style={{ backgroundColor: "#f8f9fa" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/StudentDashboard" element={<StudentDashboard />} />
            <Route path="/TeacherDashboard" element={<TeacherDashboard />} />
            <Route path="/Quizzes" element={<Quizzes />} />
            <Route path="/AiTutor" element={<AiTutor />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-student" element={<RegisterStudent />} />
            <Route path="/register-teacher" element={<RegisterTeacher />} />
            <Route path="/login" element={<Login />} />
            <Route path="/module/:moduleId" element={<ModulePage />} />
            <Route
              path="/module/:moduleId/lesson/:lessonId"
              element={<ModulePage />}
            />
            <Route path="/Lessons" element={<LessonsHub />} />
            <Route path="/quiz/:moduleId/:lessonId" element={<QuizRunner />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </main>

        {showGlobalFooter && !isQuizPage && <Footer />}
      </div>
    </>
  );
}

export default function App() {
  return <AppContent />;
}
